import React from 'react';
import {
    getFeConfig,
    submitFCConfirmation,
    getFeData,
    submitFCRefusal,
    fetchConsent,
    validateFcId,
    validateCompanyVAT,
    fetchGDPR,
    getConfirmationInfo
} from "../api/api";
import {delayMS} from "../supportFunctions"
import qs from 'query-string'
import {Form} from "@q4us-sw/q4us-ui";
import {FormElementProps} from "@q4us-sw/q4us-ui/lib/Form";
import {ConsentDocument, resolve} from "@q4us-sw/q4us-ui/lib/Cell";
import {message, Typography, Card, Select, Space, Row, Col, Descriptions, notification, Spin, Checkbox, Grid} from 'antd';
import {Trans, withTranslation} from "react-i18next";
import i18 from "../i18";
import {FormInstance} from "antd/lib/form/hooks/useForm";
import {unstable_batchedUpdates} from "react-dom";
import imgSrc from "../assets/easLogo.png";
import '../styles/FCConfirmationData.css'

const deliveryToPersonDependencies = ['fcc_recipient_title', 'fcc_recipient_first_name', 'fcc_recipient_last_name',
    'fcc_recipient_national_id', 'fcc_date_of_birth'];
const deliveryToBusinessDependencies = ['fcc_recipient_company_name', 'fcc_recipient_company_vat'];

interface Config {
    data: { statusCode: number, rows?: FormElementProps[] }
}

export interface ConsentProps {
    value?: any,
    onChange?: (data: any) => void,
    data: { [key: string]: any },
    schema: string,
    name: string
}

export const Consent: React.FunctionComponent<ConsentProps> = (props) => {

    return <div className={`consent-wrap`}>
        <div className={`consent-checkbox`}>
            <Checkbox checked={props.value} onChange={(e) => {
                props.onChange?.(e.target.checked ? e.target.checked : undefined )
            }}/>
        </div>
        <div className={`consent-text`}>
            <span>
            <Trans
                i18nKey={`${props.schema}.consents.${props.name}.declaration`}
                defaults={`${props.data.agreement_prefix} <0>${props.data.agreement_link}</0> ${props.data.agreement_suffix}`}
                components={[
                    <Typography.Link onClick={async () => {
                        await fetchGDPR();
                    }}>Terms</Typography.Link>
                ]}
            />
            </span>
        </div>
    </div>
}

const FCConfirmationData = (props: any) => {

    const redirectURI : string = props.redirectURI;
    const declineURI : string = props.declineURI;
    const value : {[key:string]: any} = props.data;

    const [pD, sePDConfig] = React.useState([] as FormElementProps[])
    const [dD, seDDConfig] = React.useState([] as FormElementProps[])
    const [loading, setLoading] = React.useState(true)
    const [consent, setConsent] = React.useState<{ [key: string]: any }>({})
    const [confirmationInfo, setConfirmationInfo] = React.useState<String>();
    const {md} = Grid.useBreakpoint()


    const load = async () => {
        const pd = await getFeConfig('fc_confirmation_personal_details') as Config;
        const dd = await getFeConfig('fc_confirmation_delivery_details') as Config;
        const {data: {rows: [_consent]}} = await fetchConsent('fc_confirmation_fe', 'fc_representation_confirm');

        unstable_batchedUpdates(() => {
            // setValue(data);
            sePDConfig(pd.data.rows || [])
            seDDConfig(dd.data.rows || [])
            setLoading(false)
            setConsent(_consent);
            props.setLoadedCb(false);
        })
    };

    React.useEffect(() => {
        load().catch(e => notification.warn({message: e.message}));
    }, []);

    return <React.Fragment>
        <Row>
            <Col>
                <img className="logo" src={imgSrc} alt="Logo"/>
            </Col>
        </Row>
        <div className="descriptions">
            {md && <div className="egg-shape"></div>}{" "}
            <Descriptions
                className="description__left"
                size="small"
                column={1}
                title={<div className="person">Personal Info</div>}
                bordered
            >
                {
                    pD.filter(q => {
                        const {fcc_is_delivery_to_person = false} = value || {};
                        if (!fcc_is_delivery_to_person) {
                            return !(deliveryToPersonDependencies.includes(q.name));
                        } else {
                            return !(deliveryToBusinessDependencies.includes(q.name));
                        }
                    }).map((o) => <Descriptions.Item
                        className="descriptionLabel"
                        label={
                            <Trans
                                defaults={o.title}
                                i18nKey={`fc_confirmation_fe.${o.name}`}
                            />}
                        style={{backgroundColor: "white"}}
                    >
                        {resolve({...o, value: value[o.name], schema: 'fc_confirmation_fe'})}
                    </Descriptions.Item>)
                }
            </Descriptions>
            {md && <div className="egg-shape2"></div>}{" "}
            <Descriptions size="small" column={1} title={<div className="person">Delivery Info</div>} bordered>
                {
                    dD.filter(q => {
                        const {fcc_is_delivery_to_person = false} = value || {};
                        if (!fcc_is_delivery_to_person) {
                            return !(deliveryToPersonDependencies.includes(q.name));
                        } else {
                            return !(deliveryToBusinessDependencies.includes(q.name));
                        }
                    }).map((o) => <Descriptions.Item
                        className="descriptionLabel"
                        label={
                            <Trans
                                defaults={o.title}
                                i18nKey={`fc_confirmation_fe.${o.name}`}
                            />}
                        style={{backgroundColor: "white"}}
                    >
                        {resolve({...o, value: value[o.name], schema: 'fc_confirmation_fe'})}
                    </Descriptions.Item>)
                }
            </Descriptions>
        </div>
        <div className={`form-wrap`}>

            {(!loading) && <Form
                schema={`fc_confirmation_fe`}
                acceptText={"Confirm"}
                rejectText={"Decline"}
                initialValue={value}
                config={async (schema: string) => {
                    const res = await getFeConfig(schema) as Config;
                    const confirmationRes = await getConfirmationInfo();
                    setConfirmationInfo(confirmationRes.data.value);
                    return res.data.rows || [];
                }}
                overrideComponent={(schema: string, element: FormElementProps, form: FormInstance<any>) => {
                    if (element.name === 'fc_representation_confirm') {
                        return <Consent data={consent} schema={schema} name={element.name}/>
                    } else if (element.name === 'fcc_recipient_company_vat') {
                    return <div className={`form-custom-input`}>
                            <div>
                                <input id={"read-only"} value={value.fcc_delivery_country_code} readOnly={true}/>
                                <input defaultValue={value.fcc_recipient_company_vat}/>
                            </div>
                            <div>
                                <label>Please enter VAT number without country identifying letters in the beginning</label>
                            </div>
                        </div>
                    } else if(element.name === 'fcc_special_note'){
                        const {
                            [element.name]: notes,
                            fcc_is_delivery_to_person : b2c,
                            fcc_recipient_company_name: company,
                            fcc_recipient_title: title,
                            fcc_recipient_first_name: fName,
                            fcc_recipient_last_name: lName
                        } = value;
                        if(notes && notes !== 'N/A'){
                            const name = b2c ? `${title || ""} ${fName || ""} ${lName || ""}` : company || "";
                            return <Trans
                                i18nKey={`${schema}.${element.name}.value`}
                                values={{name}}
                                defaults={`Dear <0>{{name}}</0>, whole or part of your order is delivered from outside of EU. Customs duties and VAT will be charged by the courier operator and you will be liable for the payment upon delivery.`}
                                components={[
                                    <strong/>
                                ]}
                            />
                        }
                    }
                    return undefined;
                }}
                submit={async (values: { [key: string]: any; }) => {

                    const {id = "", timestamp_year = ""} = value;
                    values = {...values, id, redirectURI, timestamp_year};

                    //Validate FC Id or Company VAT ID
                    const {
                        fcc_recipient_national_id,
                        fcc_date_of_birth,
                        fcc_recipient_company_vat
                    } = values;

                    if (value.fcc_is_delivery_to_person) {
                        if (fcc_recipient_national_id) {
                            const {data: fcValidation} = await validateFcId({
                                fc_id: fcc_recipient_national_id,
                                country: value.fcc_delivery_country
                            });
                            if (!fcValidation && !fcc_date_of_birth) {
                                message.error("Invalid FC Id. Provide Date of birth for submission");
                                return false;
                            }
                        }
                    }
                    else{
                        if(!fcc_recipient_company_vat) {
                            message.error("Company VAT ID Required")
                        }
                        else{
                            message.loading(`Validating VAT ID`, 0);
                            const {data: isCompanyVatValid} = await validateCompanyVAT({
                                company_vat_id : fcc_recipient_company_vat,
                                country : value.fcc_delivery_country
                            });

                            values.fcc_recipient_company_vat_validated = isCompanyVatValid;
                            if(!isCompanyVatValid){
                                message.destroy();
                                message.error("Company VAT ID invalid. Check and try again");

                                if(!localStorage.getItem('num_attempts')){
                                    localStorage.setItem('num_attempts', '1');
                                    return false;
                                }
                            }
                            else{
                                message.destroy();
                                message.success('Company VAT ID Validated');
                            }
                        }

                        if(!values.fcc_recipient_company_vat_validated){
                            message.destroy();
                            message.info('Provided VAT ID cannot be validated at this time')
                        }

                        message.loading('Order is being confirmed', 2);
                        await delayMS(2000);

                        localStorage.removeItem('num_attempts');
                    }


                    const retVal = await submitFCConfirmation(values) || {};
                    console.log(retVal);

                    const {status, data: {paymentURL}} = retVal;
                    if (status === 200) {
                        window.location.href = paymentURL;
                        return true;
                    } else {
                        return false;
                    }

                }}
                rejected={async () => {
                    const {id = "", timestamp_year = ""} = value;
                    submitFCRefusal({id, timestamp_year}).catch(e => notification.warn(e));

                    let declineRedirectURL = redirectURI;
                    if (declineURI) {
                        declineRedirectURL = declineURI;
                    }

                    window.location.href = `${declineRedirectURL}`;
                }}
                validateField={async (rule: any, _value: any, schema: string, column: FormElementProps, form: FormInstance<any>) => {
                    const {fcc_is_delivery_to_person = false} = value || {};
                    if (fcc_is_delivery_to_person) {
                        if (!(confirmationInfo === 'nothing')) {
                            if (confirmationInfo === 'birthdate' && column.name === 'fcc_date_of_birth') {
                                if (!_value)
                                    return Promise.reject(props.t(
                                        `${schema}.errors.customRequired`,
                                        '[{{label}}] is required',
                                        {
                                            label: props.t(`${schema}.${column.name}.title`, 'FC Date of Birth')
                                        }
                                    ))
                            } else if (confirmationInfo === 'personal_ID_and_birthdate') {
                                if (column.name === 'fcc_recipient_national_id') {
                                    const dob = form.getFieldsValue(['fcc_date_of_birth']) || {};
                                    if (dob['fcc_date_of_birth'] == null && _value == null)
                                        return Promise.reject(props.t(
                                            `${schema}.errors.requiredEitherAorB`,
                                            'One of either [{{a}}] or [{{b}}] is required',
                                            {
                                                a: props.t(`${schema}.${column.name}.title`, 'FC Personal ID'),
                                                b: props.t(`${schema}.fcc_date_of_birth.title`, 'FC Date of Birth')
                                            }
                                        ))
                                } else if (column.name === 'fcc_date_of_birth') {
                                    const dob = form.getFieldsValue(['fcc_recipient_national_id']) || {};
                                    if (dob['fcc_recipient_national_id'] == null && _value == null)
                                        return Promise.reject(props.t(
                                            `${schema}.errors.requiredEitherAorB`,
                                            'One of either [{{a}}] or [{{b}}] is required',
                                            {
                                                a: props.t(`${schema}.${column.name}.title`, 'FC Date of Birth'),
                                                b: props.t(`${schema}.fcc_recipient_national_id.title`, 'FC Personal ID')
                                            }
                                        ))
                                }
                            }
                        }
                    } else {
                        if (column.name === 'fcc_recipient_company_vat') {
                            if (!_value)
                                return Promise.reject(props.t(
                                    `${schema}.errors.customRequired`,
                                    '[{{label}}] is required',
                                    {
                                        label: props.t(`${schema}.${column.name}`, 'Recipient Company VAT Number')
                                    }
                                ))
                        }
                    }
                    return Promise.resolve()
                }}
                visibilityValidator={(schema, {name}, form) => {
                    const {fcc_is_delivery_to_person = false} = value || {};
                    const onlyBirthdate = ['fcc_date_of_birth', 'fc_representation_confirm','fcc_special_note'];
                    const birthdateAndPersonalId = ['fcc_date_of_birth','fcc_recipient_national_id','fc_representation_confirm','fcc_special_note'];
                    const nothing = ['fc_representation_confirm','fcc_special_note'];

                    if (!fcc_is_delivery_to_person) {
                        return !(deliveryToPersonDependencies.includes(name));
                    }
                    else {
                        switch (confirmationInfo){
                            case "birthdate":
                                return (onlyBirthdate.includes(name));
                            case "personal_ID_and_birthdate":
                                return (birthdateAndPersonalId.includes(name));
                            case "nothing":
                                return (nothing.includes(name));
                            default:
                                return (nothing.includes(name));
                        }
                    }
                }}/>}

        </div>
    </React.Fragment>
}


export const FCConfirmationDataElement = withTranslation()(FCConfirmationData)